import { createGroupStructure } from "./createGroupStructure";
import { API_ENDPOINTS } from "../../../api/endpoints";

export const parseCargaData = async (rawData) => {
  const parsedData = {
    ...rawData,
    ExcelCarga: JSON.parse(rawData.ExcelCarga),
    Settings: JSON.parse(rawData.Settings),
  };

  const CodConv = parsedData.Settings?.accountCode || parsedData.Settings?.CodConv;

  const ObtenerTarifas = API_ENDPOINTS.interna.ObtenerDataTarifa(CodConv);

  // Obtener tarifas desde la API externa
  let tarifas = [];
  try {
    const response = await fetch(ObtenerTarifas);
    if (response.ok) {
      tarifas = await response.json();
    } else {
      console.warn("Respuesta no OK al obtener tarifas");
    }
  } catch (error) {
    console.error("Error obteniendo tarifas:", error);
  }

  const groupedData = parsedData.ExcelCarga.data.reduce((acc, pasajero) => {
    const group = pasajero.Grupo;
    if (!acc[group]) acc[group] = [];
    acc[group].push(pasajero);
    return acc;
  }, {});

  const groups = Object.keys(groupedData).map((group) => {
    const groupData = groupedData[group];
    return createGroupStructure(groupData, parsedData.Settings, tarifas);
  });

  return { groups };
};
